import { render, staticRenderFns } from "./Game1v1.vue?vue&type=template&id=798db5fa&scoped=true"
import script from "./Game1v1.vue?vue&type=script&lang=js"
export * from "./Game1v1.vue?vue&type=script&lang=js"
import style0 from "./Game1v1.vue?vue&type=style&index=0&id=798db5fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798db5fa",
  null
  
)

export default component.exports